import React from 'react';
import { useIntl } from 'react-intl';
import { bool, shape, string } from 'prop-types';
import cx from 'classnames';
import {
  Typography,
  withStyles,
} from '@material-ui/core';

import styles from './styles';
import formatDateString from '../../utils/datetime';
import { getI18n, getI18nFormattedMessage } from '../../utils/intl';
import {
  PROXY_ENROLMENT_STATUS_PENDING,
  PROXY_CONNECTED,
  PROXY_DISCONNECTED,
} from '../../constants';

export const getStatusColor = (classes, status) => {
  switch (status) {
    case PROXY_ENROLMENT_STATUS_PENDING:
      return {
        statusLabel: getI18nFormattedMessage('label.proxy.details.page.status.pending.enrollment'),
        statusColorClass: classes.disabledGraphic,
      }
    case PROXY_CONNECTED:
      return {
        statusLabel: getI18nFormattedMessage('label.proxy.details.page.status.connected'),
        statusColorClass: classes.success,
      }
    case PROXY_DISCONNECTED:
      return {
        statusLabel: getI18nFormattedMessage('label.proxy.details.page.status.disconnected'),
        statusColorClass: classes.error,
      }
    default:
      return {
        statusLabel: '',
        statusColorClass: {},
      }
  }
}

export const StatusIndicator = (props) => {
  const {
    classes,
    inline,
    modifyTs,
    status,
  } = props;

  const { statusLabel, statusColorClass } = getStatusColor(classes, status);
  const lastModified = modifyTs && formatDateString(new Date(modifyTs).toString());
  const statusBarClass = inline ? cx(classes.statusBar, classes.inline) : classes.statusBar;

  const intl = getI18n(useIntl());

  return (
    <div
      className={statusBarClass}
      id="status-indicator" data-layer7-test="status-indicator"
    >
      <span className={cx(classes.status, statusColorClass)}>
        <Typography variant="body1" className={statusColorClass}>
          {statusLabel}
        </Typography>
      </span>
      {lastModified &&
        <Typography variant="body1" id="status-indicator-last-modified">
          {intl.getI18nMessage('label.last.updated')}: {lastModified}
        </Typography>
      }
    </div>
  );
};

StatusIndicator.propTypes = {
  classes: shape({}),
  inline: bool,
  modifyTs: string,
  status: string,
};
StatusIndicator.displayName = 'StatusIndicator';

export default withStyles(styles)(StatusIndicator);



// WEBPACK FOOTER //
// ./src/components/StatusIndicator/index.js